import React, { useContext, useState, useEffect } from 'react'
import ModalContext from '../../contexts/ModalContext';
import StockContext from '../../contexts/StockContext'
import { Container, HeaderText, InputRowDiv, InputDiv, InputLabel, ButtonsDiv, EditButtonDiv, ButtonImage, ButtonImageCertificate, ButtonText, MovimentButtonDiv, MovimentButtonImage, CertificateButtonDiv,  CloseDiv, CloseImg } from './style'
import { FieldsToHeaders, fieldsToHeaders, StockInterface } from '../../pages/ClientPanel/Stock/StockTable/utils'
import editPen from '../../assets/edit-pen.svg'
import activeCert from '../../assets/orders/certificate-active.svg'
import cross from '../../assets/addStockModal/cross.svg'
import doubleArrow from '../../assets/doubleArrow.svg'
import axios from 'axios';
import CertificatesContext from '../../contexts/CertificatesContext';

const newModal = () => {
    const { setModalActive, setModalSection, setItIsUpdate } =
    useContext(ModalContext)
    const { stock, setStock } = useContext(StockContext)
    const { setCertificate,  } = useContext(CertificatesContext)
    const [ activeMenu, setActiveMenu ] = useState(0)

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
            const { name, value } = e.target
        
            setStock({
                ...stock,
                [name]: value
            })
        }

    const fieldsArray: string[][] = [
        ['material', 'code'],
        ['format', 'finishing'],
        ['dimension1', 'dimension2'],
        ['lengthInMm', 'quantity'],
        ['totalWeight', 'costPerKg'],
        ['fabrication', 'heatTreatment']
        
    ]

    const modalEdit = () => {
        setItIsUpdate(true)
        setModalActive(true)
        setModalSection('firstCustomAdd')
    }

    const newMoviment = () => {
        setItIsUpdate(true)
        setModalActive(true)
        setModalSection('modalEntryOrExit')
    }

    const certificate = () => {
        setModalSection('viewCertificate')
    }

    const handleCheckCertificate = async(certificateId:number) => {
        const certificateUrl = process.env.REACT_APP_CERTIFICATES_BASE_URL
        axios.get(`${certificateUrl}/certificate/${certificateId}`)
          .then((response) => {
            setModalActive(true)
            setModalSection('viewCertificate')
            setCertificate(response.data)
          })
          .catch((error) => {
            console.error(error)
          })
      }
    

    return (
        <Container>
            <HeaderText>
                {stock.description}
            </HeaderText>
            <CloseDiv onClick={() => setModalActive(false)}>
                <CloseImg src={cross} alt='Close tab' />
            </CloseDiv>
            {fieldsArray.map((inputRow, rowIndex) => (
                <InputRowDiv key={rowIndex}>
                    {inputRow.map((stockField: string, colIndex) => (
                        <InputDiv key={colIndex}>
                            <InputLabel htmlFor={stockField}>{fieldsToHeaders[stockField as keyof FieldsToHeaders]}:</InputLabel>
                            {/* <span>{fieldsToHeaders[stockField as keyof FieldsToHeaders]}:</span> */}
                            <p className="ml-2">{stock[stockField as keyof StockInterface] || 'N/A'}</p>
                        </InputDiv>
                    ))}
                </InputRowDiv>
            ))}
            <ButtonsDiv>
                <EditButtonDiv onClick={modalEdit}>
                    <ButtonImage  src={editPen}/>
                    <ButtonText>Editar</ButtonText>
                </EditButtonDiv>
                <MovimentButtonDiv onClick={newMoviment}>
                    <MovimentButtonImage  src={doubleArrow}/>
                    <ButtonText>Novo movimento</ButtonText>
                </MovimentButtonDiv>
                {/* <CertificateButtonDiv 
                  onClick={() => stock.certificateId && handleCheckCertificate(stock.certificateId)}
                  disabled={!stock.certificateId} 
                  title={stock.certificateId ? 'Ver certificado' : 'Sem certificado'}
                >
                    <ButtonImageCertificate src={activeCert} alt='Right arrow icon' className='certImg' />
                    <ButtonText>Certificado</ButtonText>
                </CertificateButtonDiv> */}
            </ButtonsDiv>
        </Container>
    )


}

export default newModal;